import Axios from 'axios'

const reportGeneratorService = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.REPORT_RESULTS_BASE_URL
    return AxiosInstance
  },
  getMicrobiologyPartialReport (data) {
    let namePatient = data.namePatient ? '&namePatient=' + data.namePatient : ''
    let lisId = data.lisId ? '&lisId=' + data.lisId : ''
    let source = data.source ? '&source' + data.source : ''
    let alvaroId = data.alvaroId ? '&alvaroId=' + data.alvaroId : ''

    return this.axios().get(
      '/partials?' +
        'laboratoryId=' +
        data.laboratoryId +
        alvaroId +
        '&releaseDateStart=' +
        data.releaseDateStart +
        '&releaseDateEnd=' +
        data.releaseDateEnd +
        lisId +
        namePatient +
        source
    )
  }
}

export default reportGeneratorService
